import { useEffect, useState } from "react";
import { GetEmployees } from "screens/Employees/logic/GetEmployees";

export const useAssignToLogic = ({
  serviceRequest, 
  setLoading, 
  requestID, 
  navigate, 
  handleServiceRequestChange = () => console.warn('handleServiceRequestChange not provided')
}) => {

  const [allEmployees, setAllEmployees] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [checked, setChecked] = useState([]);
  const [assignedUserIds, setAssignedUserIds] = useState((serviceRequest?.assignedToUsers || []).map(user => user.userID || user.employeeID));

  useEffect(() => {
    if (requestID) {            
      fetchAllEmployees();      
    }    
  }, [requestID]);

  const filteredEmployees = (allEmployees || [])
  .filter((employee) => {
    const query = searchQuery.trim().toLowerCase();
    if (!query) return true; // Show all when search is empty
    
    const fullName = `${employee.firstName || ''} ${employee.lastName || ''}`.toLowerCase();
    return fullName.includes(query);
  });       

  const fetchAllEmployees = async () => {
    setLoading(true);
    try {  
      const Emp = await GetEmployees(0, navigate);    
      setAllEmployees(Emp);   
      setAssignedUserIds((serviceRequest?.assignedToUsers || []).map(user => user.userID || user.employeeID));               
    } catch(error){
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  
  const handleEmployeeCheck = async (employee, requestID, index) => {
    // Get current assigned IDs from local state
    const existingAssignedUserIds = assignedUserIds;

    // Check if the employee is already assigned based on employeeID
    const isAlreadyAssigned = existingAssignedUserIds.includes(employee.employeeID);

    // Determine the new assigned IDs list
    const updatedAssignedUserIds = isAlreadyAssigned
      ? existingAssignedUserIds.filter(id => id !== employee.employeeID)
      : [...existingAssignedUserIds, employee.employeeID];

    // Build payload with normalized structure: only objects with userID property
    const normalizedAssignedUsers = updatedAssignedUserIds.map(id => ({ employeeID: id }));

    
    handleServiceRequestChange('assignedToUsers', normalizedAssignedUsers);

    try {      
      
      setAssignedUserIds(updatedAssignedUserIds);

      // If you still want to track checkboxes using an index-based state:
      const currentIndex = checked.indexOf(index);
      const newChecked = [...checked];
      if (currentIndex === -1) {
        newChecked.push(index);
      } else {
        newChecked.splice(currentIndex, 1);
      }
      setChecked(newChecked);
    
    } catch (error) {
      console.error("Error saving employee selection:", error);
      // Optionally, display an error message to the user here
    }
  };

  const AssignToProps = {
    allEmployees, 
    setAllEmployees,
    filteredEmployees, 
    searchQuery, 
    setSearchQuery,  
    assignedUserIds, 
    fetchAllEmployees,
    setAssignedUserIds,
    checked, 
    setChecked,
    handleEmployeeCheck,
  };

  return { 
    AssignToProps 
  };

}